import moment from 'moment'
import i18n from '@/locales'

const getStatusWithStyle = (status) => {
  const statusStyle = {}
  switch (status) {
    case 'OK':
      statusStyle.text = i18n.t('inspection.report.status.success')
      statusStyle.color = '#008000'
      break
    case 'ERROR':
      statusStyle.text = i18n.t('inspection.report.status.error')
      statusStyle.color = '#ff0000'
      break
    default:
      break
  }
  return statusStyle
}

const getServerStatusWithStyle = (status) => {
  const statusStyle = {}
  switch (status) {
    case 'OK':
      statusStyle.text = i18n.t('inspection.report.status.server.success')
      statusStyle.color = '#008000'
      break
    case 'WARNING':
      statusStyle.text = i18n.t('inspection.report.status.server.warn')
      statusStyle.color = '#ff6600'
      break
    case 'ERROR':
      statusStyle.text = i18n.t('inspection.report.status.server.error')
      statusStyle.color = '#ff0000'
      break
    default:
      break
  }
  return statusStyle
}

export const getSubTitle = ({ title } = {}) => {
  return [
    {
      text: `${title}`,
      fontSize: 16,
      bold: true,
      margin: [0, 40, 0, 10],
    },
  ]
}

export const getSummary = ({ data } = {}) => {
  return [
    {
      style: 'summary',
      table: {
        widths: [178, 158, 568, 216],
        body: [
          [
            { text: i18n.t('inspection.report.time'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.method'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.web_console'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.env_version'), fillColor: '#eee' },
          ],
          data,
        ],
      },
    },
  ]
}

export const getSummaryData = (results, obj) => {
  const resultsArr = []
  resultsArr.push(moment(obj.created_at).format())
  resultsArr.push(i18n.t('inspection.report.method.auto'))
  resultsArr.push(i18n.t('inspection.report.status.success'))
  resultsArr.push(results.K8s[0].k8sVersion)
  return resultsArr
}

export const getMysqlHealthStatusData = (obj) => {
  const results = []

  const getAvailabilityCheck = (details = []) => {
    const checks = []
    for (const key in details) {
      if (Object.hasOwnProperty.call(details, key)) {
        const val = details[key]
        checks.push(`${i18n.t(`inspection.report.mysql.availability_check.${key}`)}: ${val}`)
      }
    }
    return checks
  }
  const getAbnormalTermination = (detail) => {
    const detailArr = detail.split(' ')
    const num = detailArr[1]

    return {
      text: [
        i18n.t('inspection.report.mysql.abnormal_termination.Aborted_connects'),
        ': ',
        { text: num, style: num > 0 ? 'warning' : '' },
      ],
    }
  }

  const getProblemAndSolution = () => {
    const solutions = []
    if (obj.Mysql.mysqlSlaveStatus === 'N/A') {
      solutions.push(`${i18n.t('inspection.report.problem_and_solution.mysql_slave')}`)
    } else if (obj.Mysql.mysqlSlaveErrorMsg) {
      if (obj.Mysql.mysqlSlaveStatus === 'OK') {
        solutions.push(`${obj.Mysql.mysqlSlaveErrorMsg}`)
      } else {
        solutions.push(`${obj.Mysql.mysqlSlaveErrorMsg} ${i18n.t('inspection.report.mysql.availability_check.slave')}`)
      }
    }
    return { ul: solutions }
  }

  if (obj.Mysql) {
    results.push([1, i18n.t('inspection.report.mysql.availability_check'), { ul: getAvailabilityCheck(obj.Mysql.mysqlStatusDetails) }, '', getStatusWithStyle(obj.Mysql.mysqlStatus)])
    results.push([2, i18n.t('inspection.report.mysql.abnormal_termination'), getAbnormalTermination(obj.Mysql.mysqlAbortedConnectionDetails), '', getStatusWithStyle(obj.Mysql.mysqlAbortedConnectionStatus)])
    results.push([
      3,
      i18n.t('inspection.report.mysql.slave_status'),
      obj.Mysql.mysqlSlaveStatus === 'N/A' ? '' : obj.Mysql.mysqlSlaveDetails,
      getProblemAndSolution(),
      obj.Mysql.mysqlSlaveStatus === 'N/A' ? i18n.t('inspection.report.mysql.slave_status.empty') : getStatusWithStyle(obj.Mysql.mysqlSlaveStatus),
    ])
  }
  return results
}

export const getK8sHealthStatusData = (k8sObj) => {
  const results = []

  const getK8sErrorPods = (k8sErrorPods = []) => {
    const pods = []

    for (const item of k8sErrorPods) {
      pods.push(`${item.namespace}/${item.podName} ${item.status}`, {
        type: 'square',
        ul: item.images || [],
      })
    }
    return pods
  }

  const getPodsCheck = (k8sDetails) => {
    const podChecks = []
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.pods')} : ${k8sDetails.pods}`)
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.runningPods')} : ${k8sDetails.runningPods}`)
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.errorPods')} : ${k8sDetails.errorPods}`, k8sDetails.errorPods > 0 ? {
      type: 'circle',
      ul: getK8sErrorPods(k8sObj.k8sErrorPods) || [],
    } : null)
    return podChecks
  }

  const getK8sErrorNodes = (k8sErrorNodes = []) => {
    const nodes = []

    for (const item of k8sErrorNodes) {
      nodes.push(`${item.name}/${item.status}/${item.internalIP}/${item.osImage}/${item.kernelVersion}`)
    }
    return nodes
  }

  const getNodesCheck = (k8sDetails) => {
    const podChecks = []
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.nodes')} : ${k8sDetails.nodes}`)
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.runningNodes')} : ${k8sDetails.runningNodes}`)
    podChecks.push(`${i18n.t('inspection.report.k8s.pods_check.errorNodes')} : ${k8sDetails.errorNodes}`, k8sDetails.errorNodes > 0 ? {
      type: 'circle',
      ul: getK8sErrorNodes(k8sObj.k8sErrorNodes) || [],
    } : null)
    return podChecks
  }

  const getK8sCert = (k8sCertDetails = []) => {
    const certs = []
    if (!k8sCertDetails || k8sCertDetails.length === 0) {
      return certs
    }
    for (const item of k8sCertDetails) {
      const certificate = item.CERTIFICATE
      const expires = moment(new Date(item.EXPIRES)).format('YYYY-MM-DD HH:mm:ss')
      certs.push(`${certificate} ${i18n.t('inspection.report.k8s.certificate_expiration_check.EXPIRES')}: ${expires}`)
    }
    return certs
  }

  const getPruneImage = (pruneImage) => {
    const pruneImages = []
    if (pruneImage && pruneImage !== 'N/A' && pruneImage.CacheSize) {
      pruneImages.push(`${i18n.t('inspection.report.k8s.prune_image.CacheSize')}: ${pruneImage.CacheSize}`)
      pruneImages.push(`${i18n.t('inspection.report.k8s.prune_image.FileList')}: `, {
        type: 'circle',
        ul: pruneImage.FileList || [],
      })
    } else {
      pruneImages.push(`${i18n.t('inspection.report.k8s.prune_image.empty')}`)
    }
    return pruneImages
  }

  const getErrorContainers = (errorContainers = []) => {
    const constainers = []
    if (!errorContainers || errorContainers.length === 0) {
      return constainers
    }
    for (const obj of errorContainers) {
      if (obj.id || obj.name) {
        constainers.push(`${obj.id}/${obj.status}/${obj.name}`)
      }
    }

    return constainers
  }

  const getImageList = (imageList = []) => {
    if (!imageList || imageList.length === 0) {
      return []
    }
    return imageList.map(item => {
      return item.images.map(img => {
        let category = item.category
        if (category.includes('/')) {
          category = category.split('/')[1]
        }
        return `${category}/${img.name}/${img.image}`
      })
    }).flat()
  }

  if (k8sObj) {
    const k8sPodsStatus = k8sObj.k8sDetails.errorPods > 0 ? 'ERROR' : 'OK'
    const k8sNodesStatus = k8sObj.k8sDetails.errorNodes > 0 ? 'ERROR' : 'OK'

    results.push([1, i18n.t('inspection.report.k8s.pods_check'), { ul: getPodsCheck(k8sObj.k8sDetails) }, '', getStatusWithStyle(k8sPodsStatus)])
    results.push([2, i18n.t('inspection.report.k8s.nodes_check'), { ul: getNodesCheck(k8sObj.k8sDetails) || [] }, '', getStatusWithStyle(k8sNodesStatus)])
    results.push([3, i18n.t('inspection.report.k8s.certificate_expiration_check'), { ul: getK8sCert(k8sObj.k8sCertDetails) }, '', getStatusWithStyle(k8sObj.k8sCertStatus)])
    results.push([4, i18n.t('inspection.report.k8s.prune_image_log_report'), { ul: getPruneImage(k8sObj.K8sPruneImageLogReport) }, '', ''])
    results.push([5, i18n.t('inspection.report.k8s.error_containers'), { ul: getErrorContainers(k8sObj.k8sErrorContainers) }, '', ''])
    results.push([6, i18n.t('inspection.report.k8s.name_and_version'), { ul: getImageList(k8sObj.K8sImageListReport) || [] }, '', ''])
  }
  return results
}

export const getHealthStatus = ({ title, data } = {}) => {
  return [
    { text: `${title}`, margin: [0, 10, 0, 8] },
    {
      table: {
        widths: [10, 228, 666, 130, 80],
        body: [
          [
            { text: i18n.t('inspection.report.columns.number'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.content'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.check_result'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.problem_and_solution'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.status'), fillColor: '#eee' },
          ],
          ...data,
        ],
      },
    },
  ]
}

export const getServerHealthStatusData = (obj) => {
  const results = []

  const getProblemAndSolution = (host) => {
    const solutions = []

    if (host.cpuStatus === 'ERROR') {
      solutions.push(`${i18n.t('inspection.report.problem_and_solution.cpu')}`)
    }
    if (parseInt(host.memUsage) > 90) {
      solutions.push(`${i18n.t('inspection.report.problem_and_solution.mem')}`)
    }
    if (host.diskStatus === 'ERROR') {
      solutions.push(`${i18n.t('inspection.report.problem_and_solution.disk')}`)
    }

    return { ul: solutions }
  }

  if (obj.Hosts && obj.Hosts.length > 0) {
    obj.Hosts.forEach((item, idx) => {
      results.push([
        idx + 1,
        item.nodeName,
        item.nodeIp,
        item.Roles?.join(',') || '',
        {
          text: [
            `${i18n.t('inspection.report.server.cpu_status')}: `,
            getStatusWithStyle(item.cpuStatus),
            `\n${i18n.t('inspection.report.server.cpu_load')}: ${item.cpuLoadLast5Min} `,
          ],
        },
        parseInt(item.memUsage) > 90 ? { text: item.memUsage, color: '#ff0000' } : item.memUsage,
        {
          text: [
            `${i18n.t('inspection.report.server.disk_status')}: `,
            getStatusWithStyle(item.diskStatus),
            `\n${i18n.t('inspection.report.server.disk_root_usage')}: ${item.diskRootUsage}`,
            `\n${i18n.t('inspection.report.server.disk_opt_usage')}: ${item.diskOptUsage === 'N/A' ? i18n.t('inspection.report.server.disk_opt_usage.empty') : item.diskOptUsage}`,
          ],
        },
        {
          text: [
            `${i18n.t('inspection.report.server.ntp_status')}: `,
            getStatusWithStyle(item.ntpStatus),
            ` \n${i18n.t('inspection.report.server.ntp_details')}: ${item.ntpDetails}`,
          ],
        },
        `${item.qemuVersion}`,
        getProblemAndSolution(item),
        getServerStatusWithStyle(item.hostStatus),
      ])
    })
  }
  return results
}

export const getServerHealthStatus = ({ title, data } = {}) => {
  return [
    { text: `${title}`, margin: [0, 10, 0, 8] },
    {
      table: {
        widths: [10, 60, 90, 60, 90, 60, 180, 160, 140, 130, 78],
        body: [
          [
            { text: i18n.t('inspection.report.columns.number'), fillColor: '#eee' },
            { text: 'Hostname', fillColor: '#eee' },
            { text: 'IP', fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.node_role'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.cpu'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.memory_usage'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.disk'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.ntp'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.qemu_version'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.problem_and_solution'), fillColor: '#eee' },
            { text: i18n.t('inspection.report.columns.status'), fillColor: '#eee' },
          ],
          ...data,
        ],
      },
    },
  ]
}

export const generateHeader = () => {
  return [
    { text: i18n.t('inspection.report'), alignment: 'center', style: 'header' },
  ]
}

export const generateStyles = () => {
  return {
    header: {
      fontSize: 22,
      bold: true,
      margin: [0, -10, 0, 0],
    },
    summary: {
      margin: [0, 20, 0, 0],
    },
    warning: {
      color: '#ff6600',
    },
  }
}
